import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { database, storage, auth } from "../../config/firebaseConfig";

const initialState = {
  users: {},
  status: "idle",
};

// A mock function to mimic making an async request for data
export function fetchUsers() {
  return database
    .ref("users/users")
    .once("value")
    .then((snap) => snap.val());
}

export function uploadAvatar(fileData) {
  const { blob, metadata } = fileData;
  const avatars = storage.ref("users").child("avatars");
  const { uid } = auth.currentUser;
  const upload = async () => {
    const uploadTask = avatars.child(metadata.name).put(blob, metadata);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused": // or 'paused'
            console.log("Upload is paused");
            break;
          case "running": // or 'running'
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          database.ref("users/users").child(`${uid}/avatar`).set(downloadURL);
        });
      }
    );
  };
  return upload();
}
// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const fetchAsync = createAsyncThunk("user/fetchUser", async () => {
  const response = await fetchUsers();
  //console.log({ response });
  // The value we return becomes the `fulfilled` action payload
  return response;
});

export const uploadAsync = createAsyncThunk(
  "user/uploadAvatar",
  async (fileData) => {
    await uploadAvatar(fileData);
    return;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    users: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      return state;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.users = action.payload;
      });
  },
});

export const { users } = userSlice.actions;

export default userSlice.reducer;
